export default __webpack_public_path__ + "static/media/gallery_03.679e7b44.jpg";